const slugify = require("@sindresorhus/slugify");

const safeSlugify = (path, options) =>
  path
    .split("/")
    .filter(Boolean)
    .map((v) => slugify(v, options))
    .join("/");

module.exports = safeSlugify;
